import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import axiosInstance from "Axiosinstance";
import CompanyCard from "./components/CompanyCard";

const PartnerCompanyDetails = () => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCompany = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.post("/api/partner/companydetials");
      if (data?.status) {
        setCompany(data.data);
      } else {
        toast.error(data?.message || "Unable to fetch company details");
      }
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Unable to fetch company details"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  return (
    <div className="page-content">
      <Row className="mb-3">
        <Col>
          <h4 className="mb-0">Company Details</h4>
        </Col>
      </Row>

      {loading ? (
        <div>Loading...</div>
      ) : !company ? (
        <div>No company details available</div>
      ) : (
        <CompanyCard
          company={company}
          readOnly={false}
          onSaved={fetchCompany}
          updateEndpoint="/api/partner/updateCompany"
        />
      )}
    </div>
  );
};

export default PartnerCompanyDetails;
